<template>
  <div>
    <b-sidebar
        id="sidebar-task-handler"
        sidebar-class="sidebar-lg"
        :visible="isTaskHandlerSidebarActive"
        bg-variant="white"
        shadow
        backdrop
        no-header
        right
        @change="(val) => $emit('update:is-task-handler-sidebar-active', val)"
        @hidden="clearForm"
    >
      <template #default="{ hide }">

        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <b-button
              v-if="taskLocal.id"
              size="sm"
              :variant="taskLocal.isCompleted ? 'outline-success' : 'outline-secondary'"
              @click="completeTask"
          >
            {{ taskLocal.isCompleted ? 'انجام شده' : 'انجام شد' }}
          </b-button>
          <h5
              v-else
              class="mb-0"
          >
            ایجاد وظیفه
          </h5>
          <div>
            <feather-icon
                class="ml-1 cursor-pointer"
                icon="StarIcon"
                size="16"
                :class="{ 'text-warning': taskLocal.isImportant }"
                @click="updateImportant"
            />
            <feather-icon
                class="ml-1 cursor-pointer"
                icon="XIcon"
                size="16"
                @click="hide"
            />
          </div>
        </div>

        <!-- Body -->

        <b-tabs content-class="mt-1" align="center">
          <b-tab :title=" taskLocal.id ? 'ویرایش' : 'ایجاد '">
            <validation-observer
                #default="{ handleSubmit }"
                ref="refFormObserver"
            >

              <!-- Form -->
              <b-form
                  class="p-2"
                  @submit.prevent="handleSubmit(onSubmit)"
                  @reset.prevent="resetForm"
              >

                <!-- Title -->
                <validation-provider
                    #default="validationContext"
                    name="عنوان"
                    rules="required"
                >
                  <b-form-group
                      label="عنوان"
                      label-for="task-title"
                  >
                    <b-form-input
                        id="task-title"
                        v-model="taskLocal.title"
                        autofocus
                        :state="getValidationState(validationContext)"
                        trim
                        placeholder="عنوان وظیفه"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <!-- Assignee -->
                <validation-provider
                    #default="validationContext"
                    name="اقدام کننده"
                    rules="required"
                >
                  <b-form-group
                      label="اقدام کننده"
                      label-for="assignee"
                      description="برای مشاهده کاربران چند حرف وارد کنید"

                  >
                    <v-select
                        v-model="taskLocal.assignee"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="assigneeOptions"
                        label="name"
                        class="assignee-selector"
                        :reduce="assignee => assignee.id"
                        input-id="id"
                        @search="onSearch"
                        :filterable="false"
                    >

                      <template #option="{ name }">

                        <span class="ml-50 d-inline-block align-middle"> {{ name }}</span>
                      </template>

                      <template #selected-option="{ name }">
                        <span class="ml-50 d-inline-block align-middle"> {{ name }}</span>
                      </template>
                    </v-select>
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <validation-provider
                    #default="validationContext"
                    name="درجه اهمیت"
                    rules="required"
                >
                  <b-form-group
                      label="درجه اهمیت"
                      label-for="priority"
                  >
                    <v-select
                        v-model="taskLocal.priority"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="prioritiesList"
                        label="title"
                        class="assignee-selector"
                        :reduce="priority => priority.id"
                        input-id="id"
                        :state="getValidationState(validationContext)"

                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>


                <b-form-group
                    label="نام پروژه"
                    label-for="project_id"
                >
                  <v-select
                      v-model="taskLocal.project"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="projectOptions"
                      label="name"
                      class="assignee-selector"
                      :reduce="project => project.id"
                      input-id="id"
                  />
                </b-form-group>
                <!-- due Date -->

                <b-form-group
                    label="تاریخ انجام"
                    label-for="due-date"
                >
                  <date-picker
                      v-model="taskLocal.dueDate"
                      type="datetime"
                      clearable
                      :min="checkDate"
                  />

                </b-form-group>

                <!--Tag -->
                <b-form-group
                    label="برچسب"
                    label-for="tag"
                >
                  <v-select
                      v-model="taskLocal.tags"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      multiple
                      :close-on-select="false"
                      :options="tagOptions"
                      label="name"
                      :reduce="tag => tag.name"
                      taggable
                      push-tags
                  />
                </b-form-group>

                <!-- Description -->
                <b-form-group
                    label="توضیح"
                    label-for="task-description"
                >
                  <quill-editor
                      id="quil-content"
                      v-model="taskLocal.description"
                      :options="editorOption"
                      class="border-bottom-0"
                  />
                  <div
                      id="quill-toolbar"
                      class="d-flex justify-content-end border-top-0"
                  >
                    <!-- Add a bold button -->
                    <button class="ql-bold"/>
                    <button class="ql-italic"/>
                    <button class="ql-underline"/>
                    <button class="ql-align"/>
                    <button class="ql-link"/>
                  </div>
                </b-form-group>

                <b-row v-for="(item, index) in attachment.items"
                       :id="item.id"
                       :key="item.id"
                >
                  <!-- Item Name -->
                  <b-col md="9" lg="10">
                    <b-form-group>
                      <label :for="`attachment_${item.id}`">
                        <feather-icon
                            icon="PaperclipIcon"
                        />
                        فایل
                      </label>
                      <b-form-file
                          v-model="item.file"
                          placeholder="فایل را انتخاب کنید یا به اینجا بکشید"
                          drop-placeholder="عکس را به اینحا بکشید"
                          no-drop
                      />
                    </b-form-group>
                  </b-col>

                  <!-- Remove Button -->
                  <b-col
                      lg="2"
                      md="3"
                      class=""
                  >
                    <b-button
                        variant="outline-danger"
                        class="mt-0 mt-md-2"
                        @click="removeItem(index)"
                    >
                      <feather-icon
                          icon="TrashIcon"
                      />
                    </b-button>
                  </b-col>
                  <b-col cols="12">
                    <hr>
                  </b-col>
                </b-row>
                <b-button
                    variant="primary"
                    @click="repeatAgain"
                >
                  <feather-icon
                      icon="PlusIcon"
                      class="mr-25"
                  />
                  <span>افزودن فایل</span>
                </b-button>
                <b-col cols="12">
                  <hr>
                </b-col>
                <!-- Form Actions -->
                <div class="d-flex mt-2 justify-content-end">
                  <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="success"
                      class="mr-2 "
                      type="submit"
                  >
                    {{ submitTitle }}
                  </b-button>
                  <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      type="reset"
                      variant="outline-secondary"
                  >
                    پاک کردن فرم
                  </b-button>
                </div>
              </b-form>
            </validation-observer>

            <h5 class="font-weight-bolder px-2" v-show="task.attachments.length">
              فایل{{ task.attachments.length > 1 ? ' ها' : '' }} ({{ task.attachments.length }})
            </h5>
            <b-list-group class="rounded-0" v-if="task.attachments && task.attachments.length">
              <b-list-group-item
                  v-for="(attachment,index) in task.attachments"
                  :key="attachment.id"
                  class="bg-transparent"
              >
                <b-link
                    :href="attachment.url"
                    target="_blank"
                    :class="{'mt-75': index}"
                >
                  <feather-icon
                      class="align-text-bottom"
                      icon="DownloadIcon"
                  />
                  <span
                      class="ml-1"
                      v-text="attachment.fileName"
                  />
                </b-link>
              </b-list-group-item>
            </b-list-group>
          </b-tab>
          <b-tab
              :title="`نظرات ${ commentsCount }`"
              :disabled="!taskLocal.id"
          >

            <validation-observer
                #default="{ handleSubmit }"
                ref="refFormObserver"
            >

              <!-- Form -->
              <b-form
                  class="p-2"
                  @submit.prevent="handleSubmit(onSubmitComment)"
                  @reset.prevent="resetFormComment"
              >

                <!-- Title -->
                <validation-provider
                    #default="validationContext"
                    name="توضیحات"
                    rules="required"
                >
                  <b-form-group
                      label="توضیح"
                      label-for="task-comment"
                  >
                    <quill-editor
                        id="quil-content-comment"
                        v-model="comment"
                        :options="editorCommentOption"
                        class="border-bottom-0"
                    />
                    <div
                        id="quill-toolbar-comment"
                        class="d-flex justify-content-end border-top-0"
                    >
                      <!-- Add a bold button -->
                      <button class="ql-bold"/>
                      <button class="ql-italic"/>
                      <button class="ql-underline"/>
                      <button class="ql-align"/>
                      <button class="ql-link"/>
                    </div>
                  </b-form-group>

                </validation-provider>

                <b-row v-for="(item, index) in commentAttachment.items"
                       :id="item.id"
                       :key="item.id"
                >
                  <!-- Item Name -->
                  <b-col md="9" lg="10">
                    <b-form-group>
                      <label :for="`comment_attachment_${item.id}`">
                        <feather-icon
                            icon="PaperclipIcon"
                        />
                        فایل
                      </label>
                      <b-form-file
                          v-model="item.file"
                          placeholder="فایل را انتخاب کنید یا به اینجا بکشید"
                          drop-placeholder="فایل را به اینحا بکشید"
                          no-drop
                      />
                    </b-form-group>
                  </b-col>

                  <!-- Remove Button -->
                  <b-col
                      lg="2"
                      md="3"
                      class=""
                  >
                    <b-button
                        variant="outline-danger"
                        class="mt-0 mt-md-2"
                        @click="removeCommentAttachItem(index)"
                    >
                      <feather-icon
                          icon="TrashIcon"
                      />
                    </b-button>
                  </b-col>
                  <b-col cols="12">
                    <hr>
                  </b-col>
                </b-row>
                <b-button
                    variant="primary"
                    @click="repeatAgainCommentAttach"
                >
                  <feather-icon
                      icon="PlusIcon"
                      class="mr-25"
                  />
                  <span>افزودن فایل</span>
                </b-button>
                <b-col cols="12">
                  <hr>
                </b-col>
                <!-- Form Actions -->
                <div class="d-flex mt-2 justify-content-end">
                  <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="success"
                      class="mr-2 "
                      type="submit"
                  >
                    {{ submitCommentTitle }}
                  </b-button>
                  <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      type="reset"
                      variant="outline-secondary"
                  >
                    پاک کردن فرم
                  </b-button>
                </div>
              </b-form>
            </validation-observer>

            <b-row class="p-1" v-if="comments.length">
              <b-col cols="12">
                <h6 class="mt-3 text-muted">
                  نظرات {{ commentsCount }}
                </h6>
              </b-col>

              <b-col>
                <b-card
                    v-for="comment in comments"
                >
                  <b-card-sub-title class="text-muted mb-1"
                                    v-text="comment.creator ? comment.creator.name : 'نامشخص'"
                  ></b-card-sub-title>
                  <b-card-text v-html="comment.body">

                  </b-card-text>
                  <b-card-text>
                    <small class="text-muted">{{ comment.createdDate }}</small>
                  </b-card-text>
                  <h5 class="font-weight-bolder px-2" v-show="comment.attachments.length">
                    فایل{{ task.attachments.length > 1 ? ' ها' : '' }} ({{ comment.attachments.length }})
                  </h5>
                  <b-list-group class="rounded-0" v-if="comment.attachments && comment.attachments.length">
                    <b-list-group-item
                        v-for="(attachment,index) in comment.attachments"
                        :key="attachment.id"
                        class="bg-transparent"
                    >
                      <b-link
                          :href="attachment.url"
                          target="_blank"
                          :class="{'mt-75': index}"
                      >
                        <feather-icon
                            class="align-text-bottom"
                            icon="DownloadIcon"
                        />
                        <span
                            class="ml-1"
                            v-text="attachment.fileName"
                        />
                      </b-link>
                    </b-list-group-item>
                  </b-list-group>
                </b-card>
              </b-col>
            </b-row>
          </b-tab>

        </b-tabs>
      </template>

    </b-sidebar>
  </div>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BAvatar,
  BButton,
  BFormInvalidFeedback,
  BCardBody,
  BCard,
  BFormFile,
  BRow,
  BCol, BCardFooter, BLink, BListGroupItem, BListGroup, BTabs, BTab, BAlert, BCardGroup, BCardText, BCardSubTitle
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required, email, url } from '@validations'
import { avatarText } from '@core/utils/filter'
import formValidation from '@core/comp-functions/forms/form-validation'
import { onMounted, toRefs, ref, computed } from '@vue/composition-api'
import { quillEditor } from 'vue-quill-editor'
import useTaskHandler from './useTaskHandler'
import axios from '@/libs/axios'
import CompositionsApiComponents from '@/views/CompositionsApiComponents'
import farsi from 'vee-validate/dist/locale/fa'
import { debounce } from '@/libs/debounce'
import { PersianNowDate } from '@/libs/utils'

export default {
  components: {
    BCardText,
    BCardSubTitle,
    BCardGroup,
    BListGroup,
    BListGroupItem,
    BLink,
    BCardFooter,
    BCol,
    BRow,
    BFormFile,
    BCard,
    BCardBody,
    // BSV
    BButton,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BAvatar,
    BFormInvalidFeedback,
    BTabs,
    BTab,
    BAlert,
    // 3rd party packages
    vSelect,
    quillEditor,

    // Form Validation
    ValidationProvider,
    ValidationObserver,

  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isTaskHandlerSidebarActive',
    event: 'update:is-task-handler-sidebar-active',
  },
  props: {
    isTaskHandlerSidebarActive: {
      type: Boolean,
      required: true,
    },
    task: {
      type: Object,
      required: true,
    },
    clearTaskData: {
      type: Function,
      required: true,
    },
    prioritiesList: {
      type: Array,
      required: true
    },
    comments: {
      type: Array,
      required: true
    },
    onProgress: {
      type: Boolean,
      required: true
    }
  },
  created() {
    localize('fa', {
      messages: farsi.messages,
    })

  },
  computed: {
    commentsCount() {
      return this.comments.length ? `(${this.comments.length})` : ''
    }
  },
  data() {
    return {
      required,
      email,
      url,
    }
  },
  setup(props, { emit }) {
    const {
      taskLocal,
      resetTaskLocal,
      checkProgress,
      // UI
      onSubmit,
      onSubmitComment,
      removeItem,
      repeatAgain,
      attachment,
      commentAttachment,
      comment,
      updateImportant,
      completeTask,
      removeCommentAttachItem,
      repeatAgainCommentAttach,

    } = useTaskHandler(toRefs(props), emit)

    const {
      showToast
    } = CompositionsApiComponents()

    const assigneeOptions = ref([])
    const tagOptions = ref([])
    const projectOptions = ref([])

    const {
      refFormObserver,
      getValidationState,
      resetForm,
      resetFormComment,
      clearForm,
    } = formValidation(resetTaskLocal, props.clearTaskData)

    // onProgress prop
    const { onProgress } = toRefs(props)

    const editorOption = {
      modules: {
        toolbar: '#quill-toolbar',
      },
      placeholder: 'توضیحات خود را وارد کنید',
    }
    const editorCommentOption = {
      modules: {
        toolbar: '#quill-toolbar-comment',
      },
      placeholder: 'توضیحات خود را وارد کنید',
    }

    // methods

    const submitTitle = computed(() => checkProgress.value ? 'در حال ارسال...' : (taskLocal.value.id ? 'ویرایش' : 'ایجاد '))
    const submitCommentTitle = computed(() => checkProgress.value ? 'در حال ارسال...' : 'ایجاد')

    const getRelatedUsers = (q) => {
      axios.get(`tasks/related-users?name=${q}`)
          .then(({ data }) => {
            if (data.status) {
              assigneeOptions.value = data.users
            } else {
              showToast('دریافت لیست دریافت کنندگان با خطا مواجه شد', {
                title: 'حطا',
                variant: 'danger'
              })
            }
          })
          .catch(error => {
            showToast(error.response.data.message ?? 'مشکلی در انجام عملیات رخ داده است.', {
              title: 'حطا',
              variant: 'danger'
            })
          })
    }

    const onSearch = (search, loading) => {
      if (search.length) {
        loading(true)
        searchUser(loading, search, this)
      }
    }
    const searchUser = debounce((loading, search, vm) => {
      getRelatedUsers(search)
      loading(false)
    }, 400)
    const getTags = () => {
      axios.get('tasks/tags')
          .then(tags => {
            tagOptions.value = tags.data
          })
          .catch(error => {
            showToast(error.response.data.message ?? 'مشکلی در انجام عملیات رخ داده است.', {
              title: 'حطا',
              variant: 'danger'
            })
          })
    }

    const getProjects = () => {
      axios.get('my-projects')
          .then(({ data }) => {
            projectOptions.value = data
          })
          .catch(error => {
            showToast(error.response.data.message ?? 'مشکلی در انجام عملیات رخ داده است.', {
              title: 'حطا',
              variant: 'danger'
            })
          })
    }

    const checkDate = computed(() => {
      return PersianNowDate()
    })

//mounted
    onMounted(() => {
      getTags()
      getProjects()
    })

    return {
      // Add New
      taskLocal,
      onSubmit,
      onSubmitComment,
      assigneeOptions,
      tagOptions,
      projectOptions,
      // Form Validation
      resetForm,
      resetFormComment,
      clearForm,
      refFormObserver,
      getValidationState,
      checkProgress,
      // UI
      editorOption,
      editorCommentOption,

      // Filter/Formatter
      avatarText,
      showToast,

      //methods
      removeItem,
      repeatAgain,
      attachment,
      comment,
      updateImportant,
      completeTask,
      removeCommentAttachItem,
      repeatAgainCommentAttach,
      commentAttachment,

      //computed
      submitTitle,
      submitCommentTitle,
      checkDate,
      onSearch,

    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/quill.scss';
</style>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';

.assignee-selector {
  ::v-deep .vs__dropdown-toggle {
    padding-left: 0;
  }
}

#quil-content ::v-deep, #quil-content-comment ::v-deep {
  > .ql-container {
    border-bottom: 0;
  }

  + #quill-toolbar, #quill-toolbar-comment {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: $border-radius;
    border-bottom-right-radius: $border-radius;

  }
}
</style>
